import React from 'react';
import { CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, ZapIcon, ChefHatIcon } from 'lucide-react';
import { PRICE, TOTAL_VALUE, DISCOUNT } from '../data/content';
import { PRODUCT_IMAGE } from '../data/productImage';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: '100% digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ChefHatIcon,
  label: 'Para cocina de casa'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}, {
  icon: CreditCardIcon,
  label: 'Precio en pesos mexicanos'
}];
const stats = [{
  value: '40 recetas',
  label: 'con rendimiento y costo por pieza'
}, {
  value: '6 menús',
  label: 'completos, con compras y cronograma'
}, {
  value: '5 bonos',
  label: 'incluida una plantilla de Excel para cotizar'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-cream" data-id="element-111" data-mp="3814cjrqd82pe">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-112" data-mp="3j897lcz58bpj">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-113" data-mp="3o7lq5lizewmb">
          <div data-id="element-114" data-mp="39al869qleg11">
            <Reveal data-id="element-115" data-mp="39b4h50y9lu2x">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-terra-dark" data-id="element-116" data-mp="399jppk78yr9a">
                Naturia Cocina · Catering para Emprender
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-117" data-mp="30hrgfctylo6a">
                Ya cocinas rico.
                <span className="block text-mint-700" data-id="element-118" data-mp="35a2fkdgvl5xs">Ahora véndelo por encargo.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-119" data-mp="2qlod43ndfjhr">
                Recetas con costo por pieza, menús completos con lista de compras y cronograma listos para empezar a vender.
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-120" data-mp="2ll0fgz4n04ek">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-121" data-mp="2ljz22o05f5to">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-sand px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-cream-line" data-id="element-122" data-mp="s3mb9x0ezovq">
                    <badge.icon className="h-4 w-4 text-terra" aria-hidden="true" data-id="element-123" data-mp="ichyn3y7og42" />
                    {badge.label}
                  </li>)}
              </ul>

              <p className="mt-8 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-124" data-mp="1b15ntam2zpmw">
                <span className="text-base text-ink-muted line-through" data-id="element-125" data-mp="1622j5ra0jlfg">{TOTAL_VALUE}</span>
                <span className="font-display text-3xl text-mint-700" data-id="element-126" data-mp="112pzffefuuh3">Hoy {PRICE}</span>
                <span className="rounded-full bg-terra-light px-2.5 py-1 text-sm font-semibold text-terra-dark" data-id="element-127" data-mp="114kjyslsskkn">
                  {DISCOUNT} de descuento
                </span>
              </p>

              <div className="mt-6" data-id="element-128" data-mp="3lqm2xztl37vg">
                <CtaButton data-id="element-129" data-mp="3hr3s5wvh8d6c">Quiero empezar a vender</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-130" data-mp="1x9kw0qpijcjb">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-131" data-mp="21awdg8y8grgf">
                    <item.icon className="h-4 w-4 text-mint-700" aria-hidden="true" data-id="element-132" data-mp="269r4tza9noc5" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <div className="flex justify-center lg:justify-end" data-id="element-133" data-mp="2g0c13g2gwgrw">
            <img src={PRODUCT_IMAGE} alt="Portada de Catering para Emprender de Naturia Cocina, México, con charolas de tostaditas de tinga, brochetas de panela con jitomate cherry y vasitos de guacamole con totopos" className="aspect-square w-full max-w-md rounded-3xl bg-cream-deep object-cover shadow-lift" width={820} height={820} loading="eager" decoding="async" fetchPriority="high" data-id="element-134" data-mp="2g258ixkwn50y" />
          </div>
        </div>

        <Reveal delay={0.05} data-id="element-135" data-mp="zlaqi1qiq6ng">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-cream-line sm:grid-cols-3" data-id="element-136" data-mp="zmlt3y8898cz">
            {stats.map(stat => <div key={stat.value} className="bg-sand px-6 py-6" data-id="element-137" data-mp="49t3ftjmawsc">
                <dt className="font-display text-2xl text-ink" data-id="element-138" data-mp="3vigoe8dy4hzd">{stat.value}</dt>
                <dd className="mt-1 text-sm text-ink-muted" data-id="element-139" data-mp="e9a6s4becyl5">{stat.label}</dd>
              </div>)}
          </dl>
        </Reveal>
      </div>
    </header>;
}